// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"061bc21dc5dba6e101ce","293":"52b2cdbb52a0f5348960","518":"571605f3efd81347ee5b","779":"ed9170ba591107d9660b"}[chunkId] + ".js";
};